export const produtoNaoInformado = 'Não informado';
